import { ref, computed, watch } from '@vue/composition-api'
// import { title } from '@core/utils/filter'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import moment from 'moment-timezone'
import router from '@/router'
import ability from '@/libs/acl/ability'
import axios from '@/libs/axios'
import { debounce } from 'lodash'

export default function useList() {
    const refListTable = ref(null)

    const toast = useToast()

    const listFilter = ref(null)

    if (router.currentRoute.params.type)
        listFilter.value = parseInt(router.currentRoute.type)

    const tableColumns = [
        {
            label: 'actions.name',
            key: 'actions'
        },
        {
            label: 'luxriot.user',
            key: 'title',
            sortable: true
        },
        {
            label: 'luxriot.password',
            key: 'password',
            sortable: true
        },
        {
            label: 'luxriot.link',
            key: 'link',
            sortable: true
        },
        {
            label: 'safr.tenant',
            key: 'tenants',
            formatter: (value, key, item) => {
                return value.map(item => { return item.name}).join(', ')
            }
        }
    ]

    const perPage = ref(10)
    const totalList = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalList.value,
        }
    })

    const fetchList = async () => {
        let params   = {
            q: searchQuery.value,
            max: perPage.value,
            'page[n]': currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            type: listFilter.value,
        }

        let { data } = await axios.get('/v1/services/luxriot/master-accounts',{ params })
        let { data: dataApi,meta,success } = data

        if (!success) {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error obteniendo la información',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })

            return []
        }

        totalList.value = meta.total

        return dataApi
    }

    const refetchData = () => {
        refListTable.value.refresh()
    }

    const contentToast = (message,type) => toast({
        component: ToastificationContent,
        props: {
            title: message,
            icon: 'CheckIcon',
            variant: type
        }
    })


    watch([listFilter, currentPage, perPage, ], () => {
        refetchData()
    })

    watch([ searchQuery ], debounce(() => {
      refetchData()
    }, 500))

    return {
        tableColumns,
        perPage,
        currentPage,
        totalList,
        fetchList,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refListTable,

        listFilter,

        refetchData,
        contentToast
    }
}
